import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginService } from './login.service';

@Injectable({ providedIn: 'root' })
export class AdministrationService {
  constructor(
    private http: HttpClient,
    private loginService: LoginService
  ) {}

  // Resolves the external administration app URL for an area ('appointments',
  // 'billing', …). Callers decide how to open it (in-place vs new tab, extra path).
  getUrl(type?: string): Observable<string> {
    return this.http.post<string>('/api/administration', { type });
  }

  // Opens the administration app: secretaries navigate in-place, everyone else
  // opens a new tab — same behaviour as the sidebar's Appointments/Billing buttons.
  redirect(type: string): void {
    this.getUrl(type).subscribe((url) => {
      if (this.loginService.userType === 'secretary') {
        window.location.href = url;
      } else {
        window.open(url, '_blank');
      }
    });
  }
}
